import { getAllLocationsEffect } from '@/redux/Savers/SaversEffects';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormSelectBox from '../Inputs/FormSelectBox';

const TrailerStoreIdSelector = ({
  placeholder,
  label,
  rules = [],
  name,
  editMode,
  margin,
  disabled,
  onChange,
  defaultValue,
  options,
  params,
}) => {
  const [trailerOptions, setTrailerOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const { selectedCompany } = useSelector((state) => state.auth);

  useEffect(() => {
    getUserList();
  }, [selectedCompany]);

  const getUserList = async () => {
    try {
      if (!options || options.length === 0) {
        setLoading(true);
        const { data } = await getAllLocationsEffect(params);

        const options = data.map((row) => ({
          label: row.branchDesc,
          value: row.branchKey,
        }));
        setTrailerOptions(options);
        setLoading(false);
      }
    } catch (error) {
      console.log('error', error);
      setTrailerOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={options ? options : trailerOptions}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      defaultValue={defaultValue}
      editMode={editMode}
      margin={margin}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default TrailerStoreIdSelector;
